import { BudgetResetTypeValues } from 'src/components/oneCorp/features/MealCredit/common/formFields/Select/BudgetResetTypeSelect/BudgetResetTypeSelect.utils';
import { MealCreditLength } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';
import { DEFAULT_WEEK_LENGTH_DAYS } from 'src/models/LineOfCreditModelUtils';

interface CalculateConsecutiveDaysProps {
  budgetLength: MealCreditLength;
  budgetResetPeriod: number | string;
  budgetResetType: BudgetResetTypeValues;
}

export function calculateConsecutiveDaysBasedOnBudgetLength({
  budgetLength,
  budgetResetPeriod = 0,
  budgetResetType,
}: CalculateConsecutiveDaysProps): number | null {
  const period = Number(budgetResetPeriod);

  const isBudgetResetPeriodValid = period > 0;

  switch (budgetLength) {
    case MealCreditLength.WEEKLY:
      return DEFAULT_WEEK_LENGTH_DAYS;

    case MealCreditLength.CUSTOM:
      if (budgetResetType === BudgetResetTypeValues.DAYS) {
        return isBudgetResetPeriodValid ? period : 1;
      }
      return isBudgetResetPeriodValid
        ? period * DEFAULT_WEEK_LENGTH_DAYS
        : DEFAULT_WEEK_LENGTH_DAYS;

    case MealCreditLength.DAILY:
    default:
      return 1;
  }
}
